import { render, staticRenderFns } from "./SummaryStudyProcess.vue?vue&type=template&id=2085e298&scoped=true"
import script from "./SummaryStudyProcess.vue?vue&type=script&lang=ts"
export * from "./SummaryStudyProcess.vue?vue&type=script&lang=ts"
import style0 from "./SummaryStudyProcess.vue?vue&type=style&index=0&id=2085e298&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2085e298",
  null
  
)

export default component.exports